// 登录模块
import loginModel from './login/index'

// 分享模块
// import share from './share/index'

window.YR = {
  version: '1.0.0',
  loginController: null,
  loginModel,
  // share
}
